import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchReporterInformation } from './reporterThunks';

interface ReporterFormState {
    [key: string]: any;
    data: any[]
}

const initialState: ReporterFormState = {
    data: []
};

export const reporterFormSlice = createSlice({
    name: 'reporterForm',
    initialState,
    reducers: {
        setFieldValue: (state, action: PayloadAction<any>) => {
            state = action.payload;
        },
        clearReporterData: (state) => {
            state.data = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchReporterInformation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchReporterInformation.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchReporterInformation.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch reporter information';
            });
    },

});

export const { setFieldValue } = reporterFormSlice.actions;
export default reporterFormSlice.reducer;
